module.exports = __webpack_public_path__ + "img/10.8f2a0f07.png";